<div class="main-page-content">
  <div class="main-page-content-block">
    <h2>AI Model Pricing</h2>
    <p class="alert alert-info">
      Prices are USD per one million tokens for the configured inference region and tier.
      Cache writes are the full write price, not a surcharge. Standard writes cover the model's default duration (5 minutes for Claude); one-hour writes have a separate price.
      Blank cache prices are unknown: cached tokens use the ordinary input price provisionally and are flagged in AI Usage.
      Enter 0 only when the provider explicitly makes that category free. Base prices remain required.
    </p>

    <div class="table-responsive">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Model</th>
            <th>Model ID</th>
            <th>Input USD / 1M tokens</th>
            <th>Output USD / 1M tokens</th>
            <th>Cache read USD / 1M</th>
            <th>Cache write (default) USD / 1M</th>
            <th>Cache write (1 hour) USD / 1M</th>
            <th>Active</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let model of models">
            <td>{{model.DisplayName}}</td>
            <td><code>{{model.ModelID}}</code></td>
            <td>
              <input [disabled]="loading" type="number" min="0" step="0.0000000001" class="form-control"
                     [(ngModel)]="model.InputUsdPerMillionTokens" />
            </td>
            <td>
              <input [disabled]="loading" type="number" min="0" step="0.0000000001" class="form-control"
                     [(ngModel)]="model.OutputUsdPerMillionTokens" />
            </td>
            <td>
              <input [disabled]="loading" type="number" min="0" step="0.0000000001" class="form-control" aria-label="Cache read price"
                     [(ngModel)]="model.CacheReadUsdPerMillionTokens" />
            </td>
            <td>
              <input [disabled]="loading" type="number" min="0" step="0.0000000001" class="form-control" aria-label="Default cache write price"
                     [(ngModel)]="model.CacheWriteUsdPerMillionTokens" />
            </td>
            <td>
              <input [disabled]="loading" type="number" min="0" step="0.0000000001" class="form-control" aria-label="One-hour cache write price"
                     [(ngModel)]="model.CacheWrite1hUsdPerMillionTokens" />
            </td>
            <td>
              <input [disabled]="loading" type="checkbox" [(ngModel)]="model.Active" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <button [disabled]="loading" class="btn btn-success" [class.button-loading]="loading" (click)="save()">Save</button>
  </div>
</div>
